module.exports = __webpack_public_path__ + "img/HyDry_sRGB.8ad0e713.png";